import { useRef, useEffect } from 'react';
import { filter, flatten, map } from 'lodash';
import axios from 'axios';
import config from 'coeus.config';
import { qlikClient } from 'constants/environmental';

const SAAS = config.saas_client === qlikClient.SAAS;

export const isEmpty = (value) => {
    if (value === undefined || value === null) {
        return true;
    }

    if (typeof value === 'object' && Object.keys(value).length === 0) {
        return true;
    }

    return typeof value === 'string' && value.trim().length === 0;
};

export const setQssOptions = (page, server) => {
    if (page && server) {
        let qsApp = page?.dynamicApp?.qsApp || page?.qsApp || server?.qsApp;

        // //Check App Id Available in the page
        // if (page.qsApp !== undefined) {
        //   if (!isEmpty(page.qsApp)) {
        //     qsApp = page.qsApp
        //   } else {
        //     qsApp = server.app
        //   }
        // } else {
        //   qsApp = server.app
        // }

        const secure = server.secure === 'YES' ? true : false;
        const protocol = secure ? 'https://' : 'http://';
        const port = server.port !== null ? parseInt(server.port) : 80;
        const prefix = isEmpty(server.prefix)
            ? isEmpty(server.externalPrefix)
                ? '/'
                : server.externalPrefix
            : `${server.prefix}`;
        const qTicket = localStorage.getItem('qTicket');
        const qlikBaseUrl = `${protocol}${server.hostname}/${prefix}/`;
        const qlikLogo = `${qlikBaseUrl}resources/hub/img/core/logo/logo-76x76.png?qlikTicket=${qTicket}`;

        return {
            config: {
                host: SAAS ? server.tenantUri : server.hostname,
                secure: secure,
                port: port,
                prefix: prefix,
                appId: qsApp,
            },
            connections: {
                vizApi: true,
                engineApi: true,
            },
            qlikBaseUrl,
            qlikLogo,
        };
    }

    return false;
};

export const getInitials = (name) => {
    return name
        .split(' ')
        .map((s) => (s.length >= 2 ? s.charAt(0).toUpperCase() : ''))
        .reduce((acc, s) => (s.length ? acc + s : acc), '');
};

export const generateMenu = (pages, match) => {
    return (
        pages &&
        pages.map((page) => {
            // console.log((page.childPages.filter(child => child._id === match.params.id).length > 0))
            return {
                isActive: page._id === match.params.id,
                activeParent:
                    page.childPages.filter(
                        (child) => child._id === match.params.id
                    ).length > 0,
                ...page,
            };
        })
    );
};

export const createMarkup = (htmlString) => ({ __html: htmlString });

export const UID = (length) => {
    const ALPHABET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const ID_LENGTH = length || 8;
    let UUID = '';
    for (let i = 0; i < ID_LENGTH; i += 1) {
        UUID += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return UUID;
};

export const makeQsOptions = (
    server,
    isAuthenticated = true,
    publicAccess = false
) => {
    let qsPrefix = server.prefix;
    if (!isAuthenticated && publicAccess) {
        qsPrefix = server.externalPrefix;
    }
    const { tenantUri, webIntegrationId } = server;
    return {
        config: {
            host: SAAS ? server.tenantUri : server.hostname,
            secure: server.secure === 'YES',
            port: parseInt(server.port) || 80,
            identity: server.identity,
            prefix: qsPrefix,
            appId: server.app,
            webIntegrationId,
            tenantUri,
        },
        connections: {
            vizApi: true,
            engineApi: true,
        },
    };
};

export const getAnonymousUserIdentity = () => {
    let identity = localStorage.getItem('identity');
    if (!identity) {
        identity = UID(16);
        localStorage.setItem('identity', identity);
    }

    return identity;
};

export const getSelectedItems = (Items, index = 0) => {
    if (Items) {
        const rows = flatten(map(Items.qMatrix, (field) => field[index]));
        const selected = filter(rows, (row) => {
            return row.qState === 'S';
        });
        return map(selected, (value) => value.qText);
    }
};

export const makeSingleFieldCube = (qsOptions, field) => {
    return {
        options: { ...qsOptions, connection: { VizApi: false } },
        cols: [field],
        qPage: {
            qTop: 0,
            qLeft: 0,
            qWidth: 1,
            qHeight: 40,
        },
    };
};

export function useIsMountedRef() {
    const isMountedRef = useRef(null);
    useEffect(() => {
        isMountedRef.current = true;
        return () => (isMountedRef.current = false);
    });
    return isMountedRef;
}

export const http = () => {
    const baseURL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/`;
    return axios.create({
        baseURL,
        headers: {
            'Content-type': 'application/json',
        },
    });
};

export const openStripePortal = (subscription) => {
    const id =
        subscription.lastSubscriptionApiResponse &&
        subscription.lastSubscriptionApiResponse.customer;
    if (id) {
        return axios
            .post('/api/subscription/portal', { id })
            .then((res) => (window.location.href = res.data))
            .catch((err) => console.log(err));
    }
    return;
};

export const formatter = {
    currency: (money, decimals = 0) => {
        money.toFixed(decimals);
        const formatMoney = new Intl.NumberFormat('en-GB', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
            style: 'currency',
            currency: 'GBP',
        });
        return formatMoney.format(money);
    },
};

export const blockHeight = ({ height, title, exportData }) => {
    if (!isEmpty(title)) {
        height = height - 30;
    }

    return height;
};

export const arrayBufferToBase64 = (data) => {
    return Buffer.from(data, 'binary').toString('base64');
};

export const pageLoadingStatus = (state) => {
    return (
        state.pages.loading || state.settings.loading || state.qsServer.loading
    );
};

export const getHash = () => {
    return window.location.hash.replace('#', '');
};

export const getAnonymousIdentity = () => {
    let identity = localStorage.getItem('identity');

    if (identity) {
        return identity;
    }

    identity = UID(24);
    localStorage.setItem('identity', identity);
    return identity;
};
